import BaseApi from '../../../infraestructure/BaseApi';

export default class ApiFinishedStatuses extends BaseApi {
    constructor(client, endPoint) {
        super(client, endPoint)
    }
}